/*=========================================================================================
	File Name: moduleAuthActions.js
	Description: Auth Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import userJson from "../../../public/user.json";
import axios from "axios";
import store from "../store";

export default {
	pullOrder({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/MarketPalce/pull/orders/" + item.companyInfoId, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("ORDER_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				console.log(err)
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("ORDER_LIST", []);
				}
				resolve(err.response);
			});
		});
	},
	cacheOrder({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + "api/uzumservice/MarketPalce/list/orders/cach", {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
							//			commit("COMPLETED_ORDER_LIST", item);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							//	commit("COMPLETED_ORDER_LIST", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	listOrder({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + "api/uzumservice/MarketPalce/list/orders/" + item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
							commit("COMPLETED_ORDER_LIST", item);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							commit("COMPLETED_ORDER_LIST", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	listOrderToOrderNumber({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		store.dispatch("auth/isTokenActive")

		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + "api/uzumservice/MarketPalce/list/orders/ordernumber?orderNumber=" + item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	listOrderProduct({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		store.dispatch("auth/isTokenActive")

		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.post(sistemAddress + "api/uzumservice/MarketPalce/list/orders/getproduct", item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
							//	commit("ORDER_PRODUCT", item);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							//	commit("ORDER_PRODUCT", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	listMarketplaceName({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		store.dispatch("auth/isTokenActive")

		if (token === null || token == "null") { }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + "api/uzumservice/MarketPalce/mpnamelist", {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = response.data;
							commit("MPNAME_LIST", item);
							resolve(response);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							commit("MPNAME_LIST", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	sendOrderToArchive({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.post(sistemAddress + "api/uzumservice/MarketPalce/send/e-archive", item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {

				}
				resolve(err.response);
			});
		});
	},
	// order collect set-up start
	addOrderToManual({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		store.dispatch("auth/isTokenActive")

		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/MarketPalce/add/orders/" + item.companyId, item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					//	commit("ADD_ITEM_STOCK", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},

	addOrderToColect({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		store.dispatch("auth/isTokenActive")

		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/OrdersCollection/add/ordercollection", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					//	commit("ADD_ITEM_STOCK", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	completeOrderColect({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		store.dispatch("auth/isTokenActive")

		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/OrdersCollection/done/ordercollection", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					//	commit("ADD_ITEM_STOCK", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	listOrderCollectHead({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		store.dispatch("auth/isTokenActive")

		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		else
			try {
				let actionMethod = "";
				if (item.companyId == "") actionMethod = "api/uzumservice/OrdersCollection/list/ordercollection/head?collectionIsDone=" + item.collectionIsDone;
				else
					actionMethod = "api/uzumservice/OrdersCollection/list/ordercollection/head/compnay/" + item.companyId + "?collectionIsDone=" + item.collectionIsDone
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + actionMethod, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
							commit("ORDER_COLLECT_HEAD", item);
							resolve(response.data);
						} else if (response.status == 400) {
							item = JSON.parse(response.data.json);
							commit("ORDER_COLLECT_HEAD", item);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							commit("ORDER_COLLECT_HEAD", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {
				console.log(error)
			}

	},
	listOrderCollectDetail({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		store.dispatch("auth/isTokenActive")

		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		else
			try {
				return new Promise((resolve, reject) => {

					axios.get(sistemAddress + "api/uzumservice/OrdersCollection/list/ordercollection/detail/collectioncode/" + item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
							commit("ORDER_COLLECT_ITEM", item);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						console.log(err)
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							commit("ORDER_COLLECT_ITEM", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	listOrderCollectControl({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		store.dispatch("auth/isTokenActive")

		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		else
			try {
				return new Promise((resolve, reject) => {

					axios.get(sistemAddress + "api/uzumservice/OrdersCollection/controls/ordercollection/" + item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
							//	commit("ORDER_COLLECT_CONTROL", item);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						console.log(err)
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							commit("ORDER_COLLECT_ITEM", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	updatetOrderCollectQuantity({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress + "api/uzumservice/OrdersCollection/update/ordercolleciton/job/" + item.orderCollecionId + "?orderCollectionId=" + item.orderCollecionId + "&barcode=" + item.barcode + "&quantity=" + item.quantity,
					{},
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response) {
						if (err.response.status == 401) {
							router.push("/login");
						} else if (err.response.status == 400) {
							// 400 hatası için gerekli işlemler
						}
						resolve(err.response);
					} else {
						console.error("Error:", err.message);
						resolve(err);
					}
				});
		});
	},
	updatetOrderCollectQuantityDown({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.put(
					sistemAddress + "api/uzumservice/OrdersCollection/update/ordercolleciton/job/down/" + item.orderCollecionId + "?orderCollectionId=" + item.orderCollecionId + "&barcode=" + item.barcode + "&quantity=" + item.quantity,
					{},
					{
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}
				)
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response) {
						if (err.response.status == 401) {
							router.push("/login");
						} else if (err.response.status == 400) {
							// 400 hatası için gerekli işlemler
						}
						resolve(err.response);
					} else {
						console.error("Error:", err.message);
						resolve(err);
					}
				});
		});
	},
	deleteOrderCollect({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/OrdersCollection/delete/ordercollection/ordernumber?orderNumber=" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {

					resolve(err.response);
				});
		});
	},
	//list order package control
	listOrderPackageScanned({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		store.dispatch("auth/isTokenActive")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + "api/uzumservice/OrderPackage/list/orderpackage/selection/item/" + item, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
	listOrderPackageControl({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		store.dispatch("auth/isTokenActive")

		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		else
			try {
				return new Promise((resolve, reject) => {
					axios.get(sistemAddress + "api/uzumservice/OrderPackage/section/orderpackage/sectioncode/" + item.sectioncode + "?barcode=" + item.barcode + "&quantity=" + item.quantity, {
						headers: {
							Authorization: `Bearer ${token}`,
							token: token
						}
					}).then(response => {
						if (response.status == 200) {
							item = JSON.parse(response.data.json);
							//				commit("ORDER_COLLECT_HEAD", item);
							resolve(response.data);
						} else if (response.status == 401) {
							router.push("/login")
						}
					}).catch(err => {
						if (err.response.status == 401) {
							router.push("/login")
						} else if (err.response.status == 400) {
							//		commit("ORDER_COLLECT_HEAD", []);
						}
						resolve(err.response);
					});
				});
			} catch (error) {

			}

	},
}
